import type {Service} from "crqlar-react-common/dist/models/service/service.model";
import {useServicesForSector} from "crqlar-react-common/dist/utils/hooks/services/useServices";
import type {ReservationsSectorState} from "../../../store/reservations.reducer";
import {usePersistentEntitySelection} from "./usePersistentEntitySelection";

export type ReservationServiceViewKey = Extract<
    ReservationsSectorState["activeTab"],
    "calendar" | "list"
>;

interface UseReservationServiceSelectionInput {
    sectorId: string;
    viewKey: ReservationServiceViewKey;
    availableServices?: Service[];
}

export interface ReservationServiceSelection {
    sectorId: string;
    viewKey: ReservationServiceViewKey;
    services: Service[];
    selectedServices: Service[];
    selectedIds: string[];
    selectedIdSet: ReadonlySet<string>;
    allSelected: boolean;
    setSelectedIds: (ids: readonly string[]) => void;
    toggleAll: () => void;
    toggleGroup: (ids: readonly string[]) => void;
    toggleService: (id: string) => void;
}

export function useReservationServiceSelection({
    sectorId,
    viewKey,
    availableServices,
}: UseReservationServiceSelectionInput): ReservationServiceSelection {
    const sectorServices = useServicesForSector(availableServices ? undefined : sectorId);
    const services = availableServices ?? sectorServices;
    const storageKey = `selectedServices-${sectorId}-${viewKey}`;
    const {
        selectedEntities: selectedServices,
        selectedIds,
        selectedIdSet,
        allSelected,
        setSelectedIds,
        toggleAll,
        toggleGroup,
        toggleEntity: toggleService,
    } = usePersistentEntitySelection({entities: services, storageKey});

    return {
        sectorId,
        viewKey,
        services,
        selectedServices,
        selectedIds,
        selectedIdSet,
        allSelected,
        setSelectedIds,
        toggleAll,
        toggleGroup,
        toggleService,
    };
}
